import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { sortByFieldAlphabetically } from "@amplio-common/funcs/commonFunctionalities";
import { simpleSetPayload } from "../constants";
import { SLICE_NAMES } from "./sliceNames";

//define root selector
const youtubeSlice_STATE_ROOT_SELECTOR = state => state[SLICE_NAMES.YOUTUBE_SLICE];

const createSimpleSelector = (fieldName) => createSelector(
  [state => state[SLICE_NAMES.YOUTUBE_SLICE][fieldName]], field => field,
);

const sortFunc = sortByFieldAlphabetically("name");

export const youtubeStudentsAdapter = createEntityAdapter({
  sortComparer: sortFunc,
});

export const youtubeMapTSToStudentStatus = (ts) => ({
  id: ts.student.id,
  name: ts.student.name,
  videoId: "",
  isPlaying: false,
  skippedTime: 0,
  progressValue: 0,
  isEnded: false,
  isError: false,
});
  
const youtubeStudentsAdapterSelectors = youtubeStudentsAdapter.getSelectors(youtubeSlice_STATE_ROOT_SELECTOR);

const initialState = {
  videoId: "",
  isPlaying: false,
  skippedTime: 0,
  isEnded: false,
  isError: false,
  ...youtubeStudentsAdapter.getInitialState(),
};

export const youtubeSlice = createSlice({
  name: SLICE_NAMES.YOUTUBE_SLICE,
  initialState,
  reducers: {
    clearYoutube: () => ({ ...initialState }),
    setVideoId: simpleSetPayload("videoId"),
    setIsPlaying: (state, action) => { state.isPlaying = action.payload.isPlaying; },
    setSkippedTime: (state, action) => { state.skippedTime = action.payload.skippedTime; },
    setIsEnded: simpleSetPayload("isEnded"),
    setIsError: simpleSetPayload("isError"),

    youtubeUpdateStudentStatus: youtubeStudentsAdapter.updateOne,
    youtubeSetStudentsStatus: youtubeStudentsAdapter.setAll,
    youtubeUpdateAllStudents: youtubeStudentsAdapter.updateMany,
  },
  extraReducers: {
  },
});

export default youtubeSlice.reducer;

//actions

export const { setVideoId, setIsPlaying, setSkippedTime, youtubeUpdateStudentStatus,
  youtubeSetStudentsStatus, youtubeUpdateAllStudents, clearYoutube, setIsEnded, setIsError } = youtubeSlice.actions;

//selectors

const selectVideoId = createSimpleSelector("videoId");
const selectIsPlaying = createSimpleSelector("isPlaying");
const selectSkippedTime = createSimpleSelector("skippedTime");
const selectIsEnded = createSimpleSelector("isEnded");
const selectIsError = createSimpleSelector("isError");

export const { selectAll: youtubeSelectAllStudentsStatus,
  selectIds: youtubeSelectStudentStatusIds, selectById: youtubeSelectStudentStatusById } = youtubeStudentsAdapterSelectors;

export { selectVideoId, selectIsPlaying, selectSkippedTime, selectIsEnded, selectIsError };
